import { jsx as _jsx } from "react/jsx-runtime";
import { CardActions } from "@mui/material";
import clsx from "clsx";
import { useStyles } from "./ui_card_actions.css";
export const UiCardActions = ({ children, className }) => {
    const classes = useStyles();
    return (_jsx(CardActions, { className: clsx(classes.ui_card_actions, className), children: children }));
};
//# sourceMappingURL=ui_card_actions.js.map